import { useState, useRef } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

import Spinner from '../spinner'
import Typography from '../typography'

import { buildFormData } from './functions'
import { submitForm } from '../../../api/bantrab'

import ArrowRight from '../icon/arrow-right.svg'

const SingleFieldForm = ({ form, pageId, submitSuccessCallback, ...attrs }) => {
  const formRef = useRef(null)
  const fields = form.formFields.slice(0, 1)
  const [formData, setFormData] = useState(buildFormData(fields))
  const [submitting, setSubmitting] = useState(false)

  const updateFormData = (event) => {
    const name = event.target.name
    const value = event.target.value

    const newFormData = { ...formData }
    newFormData[name] = value

    setFormData(newFormData)
  }

  const handleSubmit = async (event) => {
    event.preventDefault()

    if (!submitting) {
      setSubmitting(true)

      const data = {
        page: pageId,
        form: form.id,
        formData: JSON.stringify(formData),
        recaptcha: 'asdasdfasd'
      }
      let response = await submitForm(data)

      if (response.ok) {
        formRef.current.querySelectorAll('input').forEach(
          input => {
            input.value = ''
            return true
          }
        )

        if (typeof window !== 'undefined') {
          window.scrollTo(
            {
              top: 0,
              behavior: 'smooth'
            }
          )
        }

        if (submitSuccessCallback) {
          submitSuccessCallback()
        }
      }

      response = await response.json()

      setSubmitting(false)
    }
  }

  return <form
    ref={formRef}
    className={
      classNames([
        'bg-white',
        'flex',
        'flex-row',
        'items-center',
        'overflow-hidden'
      ])
    }
    style={{
      borderRadius: '1.5rem'
    }}
    method={'POST'}
    onSubmit={handleSubmit}>
    {
      fields.map((field, index) => {
        return <input
          key={index}
          name={field.cleanName}
          required={field.required}
          defaultValue={formData[field.cleanName]}
          placeholder={`Ingresa ${field.label.toLowerCase()}`}
          className={
            classNames([
              'flex-grow',
              'py-3',
              'px-6',
              'outline-none'
            ])
          }
          style={{
            borderRadius: '1.5rem 0 0 1.5rem'
          }}
          onChange={updateFormData} />
      })
    }
    <button
      type={'submit'}
      className={
        classNames(
          [
            'relative',
            'py-3',
            'px-4',
            'bg-yellow-500',
            'text-red-500',
            'flex',
            'flex-row',
            'items-center',
            'justify-center',
            'hover:bg-yellow-400',
            'active:bg-yellow-600'
          ],
          {
            'cursor-not-allowed': submitting
          }
        )
      }
      style={{
        borderRadius: '0 1.5rem 1.5rem 1.5rem',
        flexBasis: '136px',
        width: '136px'
      }}>
      {
        submitting
          ? <Spinner
            color={'white'}
            className={
              classNames([
                'absolute',
                '-top-4',
                '-bottom-4',
                'left-0',
                'rigth-0',
                'w-full'
              ])
            } />
          : null
      }
      <Typography>
        Enviar
        <ArrowRight
          width={20}
          height={20}
          className={'ml-2 inline-block'} />
      </Typography>
    </button>
  </form>
}

SingleFieldForm.propTypes = {
  form: PropTypes.object,
  pageId: PropTypes.number,
  submitSuccessCallback: PropTypes.func
}

export default SingleFieldForm
